// extracted by mini-css-extract-plugin
module.exports = {"containerClass":"LandingPage_containerClass__3scT_","containerHeadingClass":"LandingPage_containerHeadingClass__16J7C"};